import { useEffect, useState } from "react";
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { format } from "date-fns";
import { downloadFileFromStream } from "../../utils/downloadFileFromStream";
import { Spinner } from "../common/Spinner";

export enum FileMessageType {
    PICTURE,
    DOCUMENT
}

export interface FileMessageProps {
    fileId: number;
    isSender: boolean;
    fileName: string;
    type?: FileMessageType;
    sentAt: Date;
    chatId: number;
}

export const FileMessagePreview: React.FC<FileMessageProps> = (props) => {
    const [isDownloading, setIsDownloading] = useState(false);


    useEffect(() => {

    }, [])

    const handleDocumentDownload = async () => {
        setIsDownloading(true);
        await downloadFileFromStream(process.env.REACT_APP_RENTIC_API_URL! + `/files/download_rental_document/${props.chatId}/${props.fileId}`, props.fileName);
        setIsDownloading(false);
    }

    return (
        <div className={`${props.isSender ? "bg-gray-300" : "bg-blue-300"} flex w-[300px] flex-row rounded-lg items-center p-2`}>
            <div className="flex-none relative">
                <InsertDriveFileOutlinedIcon style={{width: "40px", height: "40px"}} />
                <div className="absolute w-full h-full bg-white opacity-70 top-0 rounded-lg flex justify-center align-middle items-center cursor-pointer" onClick={handleDocumentDownload}>
                    {
                        isDownloading ?
                        <Spinner size="small"/>
                        :
                        <FileDownloadOutlinedIcon style={{width: "30px", height: "30px"}}/>
                    }
                </div>
            </div>
            <div className="pl-1 flex-1 overflow-hidden flex flex-col">
                <div>{props.fileName}</div>
                <div className="text-right text-xs">{format(props.sentAt, "hh:mm").toString()}</div>
            </div>
        </div>
    )
}